export default __webpack_public_path__ + "static/media/postgraduate-outline-16px.17926758.svg";